import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../app/shared/shared.module';
import * as Services from './services/services';
import * as DaoProvider from './services/dao/daoProvider';
import {provideMasterDeprecatedChannelDao, provideMasterDmaDao} from "./services/dao/daoProvider";

// ATTENTION: Never import this module into a lazy loaded module. Only import into app module.
@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [],
  exports: [],
  providers: [
    // Daos
    DaoProvider.provideMasterUserDao(),
    DaoProvider.provideMasterRoleDao(),
    DaoProvider.provideMasterTriggerDao(),
    DaoProvider.provideMasterAdvertiserDao(),
    DaoProvider.provideMasterBrandDao(),
    DaoProvider.provideMasterActionDao(),
    DaoProvider.provideMasterDeprecatedChannelDao(),
    DaoProvider.provideMasterAgencyDao(),
    DaoProvider.provideMasterFailedMutationDao(),
    DaoProvider.provideMasterInviteDao(),
    DaoProvider.provideMasterIntegrationDao(),
    DaoProvider.provideMasterTraaqrTagDao(),
    DaoProvider.provideMasterReportDao(),
    DaoProvider.provideMasterGoogleActionDao(),
    DaoProvider.provideMasterFacebookActionDao(),
    DaoProvider.provideMasterAmazonActionDao(),
    DaoProvider.provideMasterTwitterActionDao(),
    DaoProvider.provideMasterSnapchatActionDao(),
    DaoProvider.provideMasterIntegrationInviteDao(),
    DaoProvider.provideMasterBcProductDao(),
    DaoProvider.provideMasterScheduledReportDao(),
    DaoProvider.provideMasterCustomTriggerProviderDao(),
    DaoProvider.provideMasterStationDao(),
    DaoProvider.provideMasterVidVitaDao(),
    DaoProvider.provideMasterGoalDao(),
    DaoProvider.provideMasterCustomReportDao(),
    DaoProvider.provideMasterBingActionDao(),
    DaoProvider.provideMasterTradeDeskActionDao(),
    DaoProvider.provideMasterRedshiftDao(),
    DaoProvider.provideMasterGoogleAnalyticsDao(),
    DaoProvider.provideMasterDBPediaDao(),
    DaoProvider.provideMasterPaymentDao(),
    DaoProvider.provideMasterPostlogConfigurationDao(),
    DaoProvider.provideMasterPostlogDao(),
    DaoProvider.provideMasterPostlogProviderDao(),
    DaoProvider.provideMasterBidDataDao(),
    DaoProvider.provideMasterKeywordsDao(),
    DaoProvider.provideMasterGclidDao(),
    DaoProvider.provideMasterLeadSourceDao(),
    DaoProvider.provideMasterMasterChannelDao(),
    DaoProvider.provideMasterMonitoredChannelDao(),
    DaoProvider.provideMasterChannelClusterDao(),
    DaoProvider.provideMasterDmaDao(),
    DaoProvider.provideMarketGroupDao(),
    DaoProvider.provideAthenaDao(),
    DaoProvider.provideBigQueryDao(),
    DaoProvider.provideAvsDao(),
    DaoProvider.provideLookerDao(),
    DaoProvider.provideBuyScheduleAuditDao(),
    DaoProvider.provideBuyScheduleDao(),
    DaoProvider.provideSingletonDao(),
    DaoProvider.provideStationContactsByUserDao(),
    DaoProvider.provideBuyScheduleChangeRequestDao(),
    DaoProvider.provideChannelMappingDao(),
    DaoProvider.provideChannelMappingProviderDao(),
    DaoProvider.provideScheduleAnalyticsDao(),
    DaoProvider.provideScheduleIngestConfigDao(),
    DaoProvider.provideMatchingBackfillDao(),
    DaoProvider.provideCustomerDao(),
    DaoProvider.provideFormatDao(),
    DaoProvider.provideEncoderGroupDao(),
    DaoProvider.provideProfileDao(),
    DaoProvider.provideEncodingDao(),
    DaoProvider.provideLookerDashboardMetadataDao(),
    DaoProvider.provideMasterChannelDao(),
    DaoProvider.provideMasterMarketDao(),
    /* INSERT CORE DAO PROVIDER */
    // SERVICES
    Services.AuthService,
    Services.ApiHelper,
    Services.ApiInterceptorService,
    Services.AppMessagingService,
    Services.SocketService,
    Services.SessionStorageService
  ]
})
export class CoreModule {}
